import type { TransmissionDataBus } from '@core/databus/DataBus'
import { buildTransmissionDataBus } from '@core/databus/DataBusFactory'

export class TransmissionDataBusProxy {
  static instance: TransmissionDataBus
  static getInstance(): TransmissionDataBus {
    if (!TransmissionDataBusProxy.instance) {
      TransmissionDataBusProxy.instance = buildTransmissionDataBus()
    }

    return TransmissionDataBusProxy.instance
  }
}
